import { render, staticRenderFns } from "./SetupCreate.vue?vue&type=template&id=16cc202c&"
import script from "./SetupCreate.vue?vue&type=script&lang=js&"
export * from "./SetupCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports